var jade = require("C:\\Dev\\repos\\player\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var jade_debug = [ new jade.DebugItem( 1, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ) ];
try {
var buf = [];
var jade_mixins = {};
var jade_interp;
var self = locals || {};
jade_debug.unshift(new jade.DebugItem( 0, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
jade_debug.unshift(new jade.DebugItem( 1, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<div class=\"settings-screen-wrapper\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 2, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<div class=\"overlay\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 3, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<div class=\"content-wrapper\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 4, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<span id=\"close\" onclick=\"this.parentNode.parentNode.parentNode.removeChild(this.parentNode.parentNode); return false;\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 4, jade_debug[0].filename ));
buf.push("x");
jade_debug.shift();
jade_debug.shift();
buf.push("</span>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 6, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<h3>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 6, jade_debug[0].filename ));
buf.push("Settings");
jade_debug.shift();
jade_debug.shift();
buf.push("</h3>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 8, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<div class=\"row\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 9, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<label for=\"player-ss\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 9, jade_debug[0].filename ));
buf.push("Font size video player small screen");
jade_debug.shift();
jade_debug.shift();
buf.push("</label>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 10, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<input id=\"player-ss\" type=\"text\" name=\"player-ss\"/>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 11, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<span>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 11, jade_debug[0].filename ));
buf.push("px");
jade_debug.shift();
jade_debug.shift();
buf.push("</span>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 13, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<div class=\"row\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 14, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<label for=\"player-fs\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 14, jade_debug[0].filename ));
buf.push("Font size video player full screen");
jade_debug.shift();
jade_debug.shift();
buf.push("</label>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 15, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<input id=\"player-fs\" type=\"text\" name=\"player-fs\"/>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 16, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<span>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 16, jade_debug[0].filename ));
buf.push("px");
jade_debug.shift();
jade_debug.shift();
buf.push("</span>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 18, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<div class=\"row\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 19, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<label for=\"sub-list\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 19, jade_debug[0].filename ));
buf.push("Font size of subtitle list");
jade_debug.shift();
jade_debug.shift();
buf.push("</label>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 20, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<input id=\"sub-list\" type=\"text\" name=\"sub-list\"/>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 21, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<span>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 21, jade_debug[0].filename ));
buf.push("px");
jade_debug.shift();
jade_debug.shift();
buf.push("</span>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 23, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<div class=\"row\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 24, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<label for=\"sub-position-ss\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 24, jade_debug[0].filename ));
buf.push("Subtitle position small screen(margin bottom)");
jade_debug.shift();
jade_debug.shift();
buf.push("</label>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 25, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<input id=\"sub-position-ss\" type=\"text\" name=\"sub-position-ss\"/>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 26, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<span>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 26, jade_debug[0].filename ));
buf.push("px");
jade_debug.shift();
jade_debug.shift();
buf.push("</span>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 28, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<div class=\"row\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 29, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<label for=\"sub-position-fs\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 29, jade_debug[0].filename ));
buf.push("Subtitle position full screen(margin bottom)");
jade_debug.shift();
jade_debug.shift();
buf.push("</label>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 30, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<input id=\"sub-position-fs\" type=\"text\" name=\"sub-position-fs\"/>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 31, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<span>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 31, jade_debug[0].filename ));
buf.push("px");
jade_debug.shift();
jade_debug.shift();
buf.push("</span>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 34, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<!--.row-->");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 35, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<!--\tlabel Keyboard shortcuts-->");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 36, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<!--\tlabel.short(for=\"shortcuts-yes\") Enabled-->");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 37, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<!--\tinput#shortcuts-yes(type=\"radio\", name=\"shortcuts\", value=1)-->");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 38, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<!--\tlabel.short(for=\"shortcuts-no\") Disabled-->");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 39, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<!--\tinput#shortcuts-no(type=\"radio\", name=\"shortcuts\", value=0)-->");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 39, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 40, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<div>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 41, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<input type=\"button\" value=\"Save settings\" class=\"save\"/>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 42, "C:\\Dev\\repos\\player\\app\\templates\\settings-screen.jade" ));
buf.push("<input type=\"button\" value=\"Reset settings\" class=\"reset\"/>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();;return buf.join("");
} catch (err) {
  jade.rethrow(err, jade_debug[0].filename, jade_debug[0].lineno, ".settings-screen-wrapper\r\n\t.overlay\r\n\t.content-wrapper\r\n\t\tspan#close(onclick='this.parentNode.parentNode.parentNode.removeChild(this.parentNode.parentNode); return false;') x\r\n\r\n\t\th3 Settings\r\n\r\n\t\t.row\r\n\t\t\tlabel(for=\"player-ss\") Font size video player small screen\r\n\t\t\tinput#player-ss(type=\"text\", name=\"player-ss\")\r\n\t\t\tspan px\r\n\r\n\t\t.row\r\n\t\t\tlabel(for=\"player-fs\") Font size video player full screen\r\n\t\t\tinput#player-fs(type=\"text\", name=\"player-fs\")\r\n\t\t\tspan px\r\n\r\n\t\t.row\r\n\t\t\tlabel(for=\"sub-list\") Font size of subtitle list\r\n\t\t\tinput#sub-list(type=\"text\", name=\"sub-list\")\r\n\t\t\tspan px\r\n\r\n\t\t.row\r\n\t\t\tlabel(for=\"sub-position-ss\") Subtitle position small screen(margin bottom)\r\n\t\t\tinput#sub-position-ss(type=\"text\", name=\"sub-position-ss\")\r\n\t\t\tspan px\r\n\r\n\t\t.row\r\n\t\t\tlabel(for=\"sub-position-fs\") Subtitle position full screen(margin bottom)\r\n\t\t\tinput#sub-position-fs(type=\"text\", name=\"sub-position-fs\")\r\n\t\t\tspan px\r\n\r\n\t\t//.row\r\n\t\t//\tlabel Keyboard shortcuts\r\n\t\t//\tlabel.short(for=\"shortcuts-yes\") Enabled\r\n\t\t//\tinput#shortcuts-yes(type=\"radio\", name=\"shortcuts\", value=1)\r\n\t\t//\tlabel.short(for=\"shortcuts-no\") Disabled\r\n\t\t//\tinput#shortcuts-no(type=\"radio\", name=\"shortcuts\", value=0)\r\n\r\n\t\tdiv\r\n\t\t\tinput.save(type=\"button\", value=\"Save settings\")\r\n\t\t\tinput.reset(type=\"button\", value=\"Reset settings\")");
}
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/settings-screen.jade
// module id = 420
// module chunks = 0